import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Users, Zap, Globe } from 'lucide-react';
export function Slide05WhyNow() {
  const trends = [{
    icon: TrendingUp,
    title: 'Digital ads losing effectiveness',
    desc: 'Brands need new channels'
  }, {
    icon: Globe,
    title: 'Outdoor & PR growing',
    desc: 'Shift to real-world presence'
  }, {
    icon: Zap,
    title: 'Marketing automation doubling',
    desc: 'Global growth trend'
  }, {
    icon: Users,
    title: 'Retail & FMCG seeking efficiency',
    desc: 'Cost-effective sampling needed'
  }];
  return <div className="flex flex-col h-full justify-center max-w-6xl mx-auto w-full" data-id="element-71">
      <motion.h2 className="text-5xl font-bold text-[#ffd700] mb-20 text-center" initial={{
      scale: 0.8,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} data-id="element-72">
        Why Now? (Market Shift)
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-73">
        {trends.map((trend, i) => <motion.div key={i} initial={{
        y: 50,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: i * 0.2,
        type: 'spring'
      }} className="flex items-start gap-6 p-8 rounded-2xl bg-gradient-to-br from-white/10 to-transparent border border-white/10 hover:border-[#ffd700]/50 transition-colors group" data-id="element-74">
            <div className="p-4 rounded-full bg-[#4fd1c5]/20 group-hover:bg-[#ffd700]/20 transition-colors" data-id="element-75">
              <trend.icon className="w-8 h-8 text-[#4fd1c5] group-hover:text-[#ffd700] transition-colors" data-id="element-76" />
            </div>
            <div data-id="element-77">
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-78">
                {trend.title}
              </h3>
              <p className="text-white/60 text-lg" data-id="element-79">{trend.desc}</p>
            </div>
          </motion.div>)}
      </div>
    </div>;
}